import React, { ComponentProps, ReactElement } from 'react';
import {
  I18n,
  translate,
  TranslateOptionsParams,
  TranslateOptionsWithTemplatesParams,
} from '@fiverr-private/i18n-react';
import copies from '../copies.json';

type Copies = typeof copies;

type DeepKeysOf<T, Key extends keyof T = keyof T> = Key extends string
  ? T[Key] extends Record<'one' | 'other', string>
    ? Key
    : T[Key] extends Record<string, any>
    ? `${Key}.${DeepKeysOf<T[Key]>}`
    : Key | (T[Key] extends string ? `${Key}.${T[Key]}` : never)
  : never;

type TranslationKey = DeepKeysOf<Copies>;

export type FormattedTranslationKey = ExtractAfterDot<TranslationKey>;

type ExtractAfterDot<T> = T extends `dm_brief_creation.${infer Rest}` ? Rest : never;

export function appTranslate<T extends string | ReactElement = string>(
  key: FormattedTranslationKey,
  options?: TranslateOptionsParams
): T;

export function appTranslate<T extends string | ReactElement = ReactElement>(
  key: FormattedTranslationKey,
  options: TranslateOptionsWithTemplatesParams
): T;

export function appTranslate(
  key: FormattedTranslationKey,
  options?: TranslateOptionsParams | TranslateOptionsWithTemplatesParams
) {
  return translate(`dm_brief_creation.${key}`, options);
}

export interface AppI18nProps extends Omit<ComponentProps<typeof I18n>, 'k'> {
  k: FormattedTranslationKey;
}

export function AppI18n({ k, ...rest }: AppI18nProps) {
  return <I18n k={`dm_brief_creation.${k}`} {...rest} />;
}

export type InvalidIntent = keyof Pick<
  typeof copies.dm_brief_creation.generation_errors,
  'non_english' | 'non_service' | 'insufficient_information' | 'contact_support' | 'seller_intent' | 'tos_violation'
>;

export const invalidIntents: InvalidIntent[] = [
  'non_english',
  'non_service',
  'insufficient_information',
  'contact_support',
  'seller_intent',
  'tos_violation',
];

export type GenerationError = keyof typeof copies.dm_brief_creation.generation_errors;
